/** TanStack Query key for `GET /v1/roster/students/me`. */
export const ROSTER_STUDENT_ME_QUERY_KEY = ['roster', 'student', 'me'] as const;
